import { RouteObject } from 'react-router'
import notificationsRoutes from './notifications/routes'
import menusRoutes from './menus/routes'

const routes: RouteObject[] = [...notificationsRoutes, ...menusRoutes]

export default routes
